import React, { useState } from 'react'
import { toast } from 'react-toastify';
import Select from 'react-select';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
const PayableTab = () => {
    const [rows, setRows] = useState([
        {
            organization_branch: '',
            bank_name: '',
            bank_branch: '',
            account_number: '',
            ifsc: '',
            swift_code: '',
            micr_no: '',
            payee_name: '',
            payee_details: '',
            default: false,
        },
    ]);
    // Function to add a new row
    const CurrOpt = [{ value: 'chocolate', label: 'Chocolate' },
        { value: 'strawberry', label: 'Strawberry' },
        { value: 'vanilla', label: 'Vanilla' },];
    const addRow = async () => {
        const currentRow = rows[rows.length - 1];

        // Check if the current row exists and if all its fields are filled
        if (currentRow && Object.values(currentRow).every(field => field !== '')) {
            // If all fields are filled, add a new row with empty fields
            setRows([...rows, {
                organization_branch: '',
                bank_name: '',
                bank_branch: '',
                account_number: '',
                ifsc: '',
                swift_code: '',
                micr_no: '',
                payee_name: '',
                payee_details: '',
                default: false,
            }]);
        } else {
            // Show an error message if any field is empty
            toast.error('Please fill all fields before adding a new row.');
        }
    };

    // Function to remove a row
    const removeRow = (index) => {
        if (rows.length > 1) {
            const updatedRows = rows.filter((_, i) => i !== index);
            setRows(updatedRows);
            // formik.setFieldValue('rows', updatedRows);
        } else {
            alert('At least one row must remain.');
        }
    };

    // Handle input change in each row
    const handleInputChange = (index, event) => {
        const { name, value } = event.target;
        const updatedRows = [...rows];
        updatedRows[index][name] = value;
        setRows(updatedRows);
        // formik.setFieldValue(`rows[${index}].${name}`, value);
    };
    return (
        <>
            <div className="table-responsive ">
                {/* <Table className="table datanew dataTable no-footer" pagination={false}
            dataSource={dataSource} columns={columns} /> */}
                <table className="table table-responsive border custom-table-th">
                    <thead>
                        <tr>
                            <th scope="col" className='bg-none'>Action</th>
                            <th scope="col" className='bg-none w-min-120'>Organization Branch</th>
                            <th scope="col" className='bg-none w-min-120'>Bank Name</th>
                            <th scope="col" className='bg-none w-min-120'>Bank Branch</th>
                            <th scope="col" className='bg-none w-min-120'>Account Number</th>
                            <th scope="col" className='bg-none w-min-120'>IFSC</th>
                            <th scope="col" className='bg-none w-min-120'>Swift Code</th>
                            <th scope="col" className='bg-none w-min-120'>MICR No</th>
                            <th scope="col" className='bg-none w-min-120'>Payee Name</th>
                            <th scope="col" className='bg-none w-min-120'>Payee Details</th>
                            <th scope="col" className='bg-none w-min-120'>Default</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, index) => (
                            <tr key={index}>
                                <td>
                                    <div className="d-flex">
                                        <div className="add-icon cursor-pointer" onClick={addRow}>
                                            <AddIcon />
                                        </div>
                                        {index > 0 && (
                                            <div className="remove-icon cursor-pointer" onClick={() => removeRow(index)} style={{ marginLeft: '10px' }}>
                                                <DeleteIcon />
                                            </div>
                                        )}
                                    </div>
                                </td>
                                {/* Add input fields for each column */}
                                <td><input type="text" className="form-control form-control-sm" name="organization_branch" placeholder="Enter Organization Branch" value={row.organization_branch} onChange={(event) => handleInputChange(index, event)} /></td>
                                <td><input type="text" className="form-control form-control-sm" name="bank_name" placeholder="Enter Bank Name" value={row.bank_name} onChange={(event) => handleInputChange(index, event)} /></td>
                                <td><input type="text" className="form-control form-control-sm" name="bank_branch" placeholder="Enter Bank Branch" value={row.bank_branch} onChange={(event) => handleInputChange(index, event)} /></td>
                                <td><input type="text" className="form-control form-control-sm" name="account_number" placeholder="Enter Account Number" value={row.account_number} onChange={(event) => handleInputChange(index, event)} /></td>
                                <td><input type="text" className="form-control form-control-sm" name="ifsc" placeholder="Enter IFSC" value={row.ifsc} onChange={(event) => handleInputChange(index, event)} /></td>
                                <td><input type="text" className="form-control form-control-sm" name="swift_code" placeholder="Enter Swift Code" value={row.swift_code} onChange={(event) => handleInputChange(index, event)} /></td>
                                <td><input type="text" className="form-control form-control-sm" name="micr_no" placeholder="Enter MICR No" value={row.micr_no} onChange={(event) => handleInputChange(index, event)} /></td>
                                <td><input type="text" className="form-control form-control-sm" name="payee_name" placeholder="Enter Payee Name" value={row.payee_name} onChange={(event) => handleInputChange(index, event)} /></td>
                                <td><input type="text" className="form-control form-control-sm" name="payee_details" placeholder="Enter Payee Details" value={row.payee_details} onChange={(event) => handleInputChange(index, event)} /></td>
                                <td><input type="checkbox" name="default" checked={row.default} onChange={(event) => handleInputChange(index, event)} /></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default PayableTab